// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/grouping.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { LucideIcon } from "./common";

export const protobufPackage = "api.devplan.types.grouping";

export interface Group {
  id: string;
  name: string;
  topLevelItems: string[];
  items: GroupItem[];
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  companyId: number;
  revision: number;
}

export interface GroupTimeline {
  itemTimelines: { [key: string]: GroupItemTimeline };
}

export interface GroupTimeline_ItemTimelinesEntry {
  key: string;
  value: GroupItemTimeline | undefined;
}

export interface GroupItem {
  key: string;
  entityId: string;
  noDrag: boolean;
  childItems: string[];
  rootOnly: boolean;
  noDrop: boolean;
  childrenNoDrag: boolean;
  type:
    | { $case: "document"; value: GroupDocument }
    | { $case: "project"; value: GroupProject }
    | { $case: "section"; value: GroupSection }
    | { $case: "user"; value: GroupUser }
    | undefined;
}

export interface GroupDocument {
}

export interface GroupProject {
}

export interface GroupUser {
}

export interface GroupSection {
  name: string;
  icon?: LucideIcon | undefined;
}

export interface GroupItemTimeline {
  start: DateEstimate | undefined;
  end: DateEstimate | undefined;
}

export interface DateEstimate {
  ts: Date | undefined;
}

function createBaseGroup(): Group {
  return {
    id: "",
    name: "",
    topLevelItems: [],
    items: [],
    createdAt: undefined,
    updatedAt: undefined,
    companyId: 0,
    revision: 0,
  };
}

export const Group: MessageFns<Group> = {
  encode(message: Group, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    for (const v of message.topLevelItems) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.items) {
      GroupItem.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(42).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(50).fork()).join();
    }
    if (message.companyId !== 0) {
      writer.uint32(56).int32(message.companyId);
    }
    if (message.revision !== 0) {
      writer.uint32(64).int32(message.revision);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Group {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.topLevelItems.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.items.push(GroupItem.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.revision = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Group {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      topLevelItems: globalThis.Array.isArray(object?.topLevelItems)
        ? object.topLevelItems.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.top_level_items)
        ? object.top_level_items.map((e: any) => globalThis.String(e))
        : [],
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => GroupItem.fromJSON(e)) : [],
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      revision: isSet(object.revision) ? globalThis.Number(object.revision) : 0,
    };
  },

  toJSON(message: Group): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.topLevelItems?.length) {
      obj.topLevelItems = message.topLevelItems;
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => GroupItem.toJSON(e));
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.revision !== 0) {
      obj.revision = Math.round(message.revision);
    }
    return obj;
  },

  create(base?: DeepPartial<Group>): Group {
    return Group.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Group>): Group {
    const message = createBaseGroup();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.topLevelItems = object.topLevelItems?.map((e) => e) || [];
    message.items = object.items?.map((e) => GroupItem.fromPartial(e)) || [];
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.companyId = object.companyId ?? 0;
    message.revision = object.revision ?? 0;
    return message;
  },
};

function createBaseGroupTimeline(): GroupTimeline {
  return { itemTimelines: {} };
}

export const GroupTimeline: MessageFns<GroupTimeline> = {
  encode(message: GroupTimeline, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.itemTimelines).forEach(([key, value]: [string, GroupItemTimeline]) => {
      GroupTimeline_ItemTimelinesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupTimeline {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupTimeline();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = GroupTimeline_ItemTimelinesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.itemTimelines[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroupTimeline {
    return {
      itemTimelines: isObject(object.itemTimelines)
        ? (globalThis.Object.entries(object.itemTimelines) as [string, any][]).reduce(
          (acc: { [key: string]: GroupItemTimeline }, [key, value]: [string, any]) => {
            acc[key] = GroupItemTimeline.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.item_timelines)
        ? (globalThis.Object.entries(object.item_timelines) as [string, any][]).reduce(
          (acc: { [key: string]: GroupItemTimeline }, [key, value]: [string, any]) => {
            acc[key] = GroupItemTimeline.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: GroupTimeline): unknown {
    const obj: any = {};
    if (message.itemTimelines) {
      const entries = globalThis.Object.entries(message.itemTimelines) as [string, GroupItemTimeline][];
      if (entries.length > 0) {
        obj.itemTimelines = {};
        entries.forEach(([k, v]) => {
          obj.itemTimelines[k] = GroupItemTimeline.toJSON(v);
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<GroupTimeline>): GroupTimeline {
    return GroupTimeline.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GroupTimeline>): GroupTimeline {
    const message = createBaseGroupTimeline();
    message.itemTimelines = (globalThis.Object.entries(object.itemTimelines ?? {}) as [string, GroupItemTimeline][])
      .reduce((acc: { [key: string]: GroupItemTimeline }, [key, value]: [string, GroupItemTimeline]) => {
        if (value !== undefined) {
          acc[key] = GroupItemTimeline.fromPartial(value);
        }
        return acc;
      }, {});
    return message;
  },
};

function createBaseGroupTimeline_ItemTimelinesEntry(): GroupTimeline_ItemTimelinesEntry {
  return { key: "", value: undefined };
}

export const GroupTimeline_ItemTimelinesEntry: MessageFns<GroupTimeline_ItemTimelinesEntry> = {
  encode(message: GroupTimeline_ItemTimelinesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      GroupItemTimeline.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupTimeline_ItemTimelinesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupTimeline_ItemTimelinesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = GroupItemTimeline.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroupTimeline_ItemTimelinesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? GroupItemTimeline.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: GroupTimeline_ItemTimelinesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = GroupItemTimeline.toJSON(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<GroupTimeline_ItemTimelinesEntry>): GroupTimeline_ItemTimelinesEntry {
    return GroupTimeline_ItemTimelinesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GroupTimeline_ItemTimelinesEntry>): GroupTimeline_ItemTimelinesEntry {
    const message = createBaseGroupTimeline_ItemTimelinesEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? GroupItemTimeline.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseGroupItem(): GroupItem {
  return {
    key: "",
    entityId: "",
    noDrag: false,
    childItems: [],
    rootOnly: false,
    noDrop: false,
    childrenNoDrag: false,
    type: undefined,
  };
}

export const GroupItem: MessageFns<GroupItem> = {
  encode(message: GroupItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.entityId !== "") {
      writer.uint32(18).string(message.entityId);
    }
    if (message.noDrag !== false) {
      writer.uint32(24).bool(message.noDrag);
    }
    for (const v of message.childItems) {
      writer.uint32(34).string(v!);
    }
    if (message.rootOnly !== false) {
      writer.uint32(40).bool(message.rootOnly);
    }
    if (message.noDrop !== false) {
      writer.uint32(48).bool(message.noDrop);
    }
    if (message.childrenNoDrag !== false) {
      writer.uint32(56).bool(message.childrenNoDrag);
    }
    switch (message.type?.$case) {
      case "document":
        GroupDocument.encode(message.type.value, writer.uint32(802).fork()).join();
        break;
      case "project":
        GroupProject.encode(message.type.value, writer.uint32(810).fork()).join();
        break;
      case "section":
        GroupSection.encode(message.type.value, writer.uint32(818).fork()).join();
        break;
      case "user":
        GroupUser.encode(message.type.value, writer.uint32(826).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.entityId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.noDrag = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.childItems.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.rootOnly = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.noDrop = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.childrenNoDrag = reader.bool();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.type = { $case: "document", value: GroupDocument.decode(reader, reader.uint32()) };
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.type = { $case: "project", value: GroupProject.decode(reader, reader.uint32()) };
          continue;
        }
        case 102: {
          if (tag !== 818) {
            break;
          }

          message.type = { $case: "section", value: GroupSection.decode(reader, reader.uint32()) };
          continue;
        }
        case 103: {
          if (tag !== 826) {
            break;
          }

          message.type = { $case: "user", value: GroupUser.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroupItem {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      entityId: isSet(object.entityId)
        ? globalThis.String(object.entityId)
        : isSet(object.entity_id)
        ? globalThis.String(object.entity_id)
        : "",
      noDrag: isSet(object.noDrag)
        ? globalThis.Boolean(object.noDrag)
        : isSet(object.no_drag)
        ? globalThis.Boolean(object.no_drag)
        : false,
      childItems: globalThis.Array.isArray(object?.childItems)
        ? object.childItems.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.child_items)
        ? object.child_items.map((e: any) => globalThis.String(e))
        : [],
      rootOnly: isSet(object.rootOnly)
        ? globalThis.Boolean(object.rootOnly)
        : isSet(object.root_only)
        ? globalThis.Boolean(object.root_only)
        : false,
      noDrop: isSet(object.noDrop)
        ? globalThis.Boolean(object.noDrop)
        : isSet(object.no_drop)
        ? globalThis.Boolean(object.no_drop)
        : false,
      childrenNoDrag: isSet(object.childrenNoDrag)
        ? globalThis.Boolean(object.childrenNoDrag)
        : isSet(object.children_no_drag)
        ? globalThis.Boolean(object.children_no_drag)
        : false,
      type: isSet(object.document)
        ? { $case: "document", value: GroupDocument.fromJSON(object.document) }
        : isSet(object.project)
        ? { $case: "project", value: GroupProject.fromJSON(object.project) }
        : isSet(object.section)
        ? { $case: "section", value: GroupSection.fromJSON(object.section) }
        : isSet(object.user)
        ? { $case: "user", value: GroupUser.fromJSON(object.user) }
        : undefined,
    };
  },

  toJSON(message: GroupItem): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.entityId !== "") {
      obj.entityId = message.entityId;
    }
    if (message.noDrag !== false) {
      obj.noDrag = message.noDrag;
    }
    if (message.childItems?.length) {
      obj.childItems = message.childItems;
    }
    if (message.rootOnly !== false) {
      obj.rootOnly = message.rootOnly;
    }
    if (message.noDrop !== false) {
      obj.noDrop = message.noDrop;
    }
    if (message.childrenNoDrag !== false) {
      obj.childrenNoDrag = message.childrenNoDrag;
    }
    if (message.type?.$case === "document") {
      obj.document = GroupDocument.toJSON(message.type.value);
    } else if (message.type?.$case === "project") {
      obj.project = GroupProject.toJSON(message.type.value);
    } else if (message.type?.$case === "section") {
      obj.section = GroupSection.toJSON(message.type.value);
    } else if (message.type?.$case === "user") {
      obj.user = GroupUser.toJSON(message.type.value);
    }
    return obj;
  },

  create(base?: DeepPartial<GroupItem>): GroupItem {
    return GroupItem.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GroupItem>): GroupItem {
    const message = createBaseGroupItem();
    message.key = object.key ?? "";
    message.entityId = object.entityId ?? "";
    message.noDrag = object.noDrag ?? false;
    message.childItems = object.childItems?.map((e) => e) || [];
    message.rootOnly = object.rootOnly ?? false;
    message.noDrop = object.noDrop ?? false;
    message.childrenNoDrag = object.childrenNoDrag ?? false;
    switch (object.type?.$case) {
      case "document": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "document", value: GroupDocument.fromPartial(object.type.value) };
        }
        break;
      }
      case "project": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "project", value: GroupProject.fromPartial(object.type.value) };
        }
        break;
      }
      case "section": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "section", value: GroupSection.fromPartial(object.type.value) };
        }
        break;
      }
      case "user": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "user", value: GroupUser.fromPartial(object.type.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseGroupDocument(): GroupDocument {
  return {};
}

export const GroupDocument: MessageFns<GroupDocument> = {
  encode(_: GroupDocument, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupDocument {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupDocument();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GroupDocument {
    return {};
  },

  toJSON(_: GroupDocument): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<GroupDocument>): GroupDocument {
    return GroupDocument.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<GroupDocument>): GroupDocument {
    const message = createBaseGroupDocument();
    return message;
  },
};

function createBaseGroupProject(): GroupProject {
  return {};
}

export const GroupProject: MessageFns<GroupProject> = {
  encode(_: GroupProject, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupProject {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupProject();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GroupProject {
    return {};
  },

  toJSON(_: GroupProject): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<GroupProject>): GroupProject {
    return GroupProject.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<GroupProject>): GroupProject {
    const message = createBaseGroupProject();
    return message;
  },
};

function createBaseGroupUser(): GroupUser {
  return {};
}

export const GroupUser: MessageFns<GroupUser> = {
  encode(_: GroupUser, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupUser {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GroupUser {
    return {};
  },

  toJSON(_: GroupUser): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<GroupUser>): GroupUser {
    return GroupUser.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<GroupUser>): GroupUser {
    const message = createBaseGroupUser();
    return message;
  },
};

function createBaseGroupSection(): GroupSection {
  return { name: "", icon: undefined };
}

export const GroupSection: MessageFns<GroupSection> = {
  encode(message: GroupSection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.icon !== undefined) {
      LucideIcon.encode(message.icon, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupSection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupSection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.icon = LucideIcon.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroupSection {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      icon: isSet(object.icon) ? LucideIcon.fromJSON(object.icon) : undefined,
    };
  },

  toJSON(message: GroupSection): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.icon !== undefined) {
      obj.icon = LucideIcon.toJSON(message.icon);
    }
    return obj;
  },

  create(base?: DeepPartial<GroupSection>): GroupSection {
    return GroupSection.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GroupSection>): GroupSection {
    const message = createBaseGroupSection();
    message.name = object.name ?? "";
    message.icon = (object.icon !== undefined && object.icon !== null)
      ? LucideIcon.fromPartial(object.icon)
      : undefined;
    return message;
  },
};

function createBaseGroupItemTimeline(): GroupItemTimeline {
  return { start: undefined, end: undefined };
}

export const GroupItemTimeline: MessageFns<GroupItemTimeline> = {
  encode(message: GroupItemTimeline, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.start !== undefined) {
      DateEstimate.encode(message.start, writer.uint32(10).fork()).join();
    }
    if (message.end !== undefined) {
      DateEstimate.encode(message.end, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupItemTimeline {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupItemTimeline();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.start = DateEstimate.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.end = DateEstimate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroupItemTimeline {
    return {
      start: isSet(object.start) ? DateEstimate.fromJSON(object.start) : undefined,
      end: isSet(object.end) ? DateEstimate.fromJSON(object.end) : undefined,
    };
  },

  toJSON(message: GroupItemTimeline): unknown {
    const obj: any = {};
    if (message.start !== undefined) {
      obj.start = DateEstimate.toJSON(message.start);
    }
    if (message.end !== undefined) {
      obj.end = DateEstimate.toJSON(message.end);
    }
    return obj;
  },

  create(base?: DeepPartial<GroupItemTimeline>): GroupItemTimeline {
    return GroupItemTimeline.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GroupItemTimeline>): GroupItemTimeline {
    const message = createBaseGroupItemTimeline();
    message.start = (object.start !== undefined && object.start !== null)
      ? DateEstimate.fromPartial(object.start)
      : undefined;
    message.end = (object.end !== undefined && object.end !== null) ? DateEstimate.fromPartial(object.end) : undefined;
    return message;
  },
};

function createBaseDateEstimate(): DateEstimate {
  return { ts: undefined };
}

export const DateEstimate: MessageFns<DateEstimate> = {
  encode(message: DateEstimate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ts !== undefined) {
      Timestamp.encode(toTimestamp(message.ts), writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DateEstimate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDateEstimate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ts = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DateEstimate {
    return { ts: isSet(object.ts) ? fromJsonTimestamp(object.ts) : undefined };
  },

  toJSON(message: DateEstimate): unknown {
    const obj: any = {};
    if (message.ts !== undefined) {
      obj.ts = message.ts.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<DateEstimate>): DateEstimate {
    return DateEstimate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DateEstimate>): DateEstimate {
    const message = createBaseDateEstimate();
    message.ts = object.ts ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
